
          import "Tertiary_12xg3fk.linaria.css";
          import { styled } from "@linaria/react";
import { focusStyle } from "@carvana/showroom-css-theme";
import Button from "./Base";
export default /*#__PURE__*/styled(Button)({
  name: "Tertiary0",
  class: "t1vby3eh"
});
          